import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { jwtDecode } from 'jwt-decode'
import MainLoader from 'components/CommonComponents/MainLoader'
import Auth from 'services/authService'
import { setToken, setUserId } from 'redux/actions/auth'

export const PENDING_PUSH_NOTIFICATION_KEY = 'pending_push_notification'

// Landing spot for `clients.openWindow(...)` in public/push-sw.js when the app wasn't open at
// all when a push notification was clicked (cold start). RequireAuth would otherwise strip the
// `n` query param on its redirect to the login flow, so it's stashed in sessionStorage instead —
// App.tsx's bootstrap effect picks it up and resolves the real destination once auth/config are
// ready. This route intentionally has no RequireAuth — there may be no session yet.
const NotificationBootstrap: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    let isMounted = true

    const bootstrapNotificationOpen = async () => {
      const raw = new URLSearchParams(window.location.search).get('n')
      if (raw) sessionStorage.setItem(PENDING_PUSH_NOTIFICATION_KEY, raw)

      try {
        const tokenResult = await Auth.getUpdatedToken()
        const token = typeof tokenResult === 'string' ? tokenResult : tokenResult?.token

        if (token) {
          const payload: any = jwtDecode(token)
          dispatch(setToken(token))
          const userId = payload?.['cognito:username']
          if (userId) dispatch(setUserId(userId))
        }
      } catch (err) {
        console.warn('[Notifications] failed to restore auth before notification open:', err)
      } finally {
        if (isMounted) navigate('/', { replace: true })
      }
    }

    bootstrapNotificationOpen()

    return () => {
      isMounted = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <MainLoader isShow />
}

export default NotificationBootstrap
